import { render, staticRenderFns } from "./ChallengeFollowButton.vue?vue&type=template&id=6d603d08"
import script from "./ChallengeFollowButton.vue?vue&type=script&lang=ts"
export * from "./ChallengeFollowButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports